import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { Button, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faThumbtack,
  faTimes,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

class TitleBar extends Component {
  render() {
    let pinStyle = {};

    if (!this.props.pinned) {
      pinStyle.transform = 'rotate(45deg)';
    }

    return (
      <div className="menu-title">
        <div className="menu-title-button">
          <Button
            onClick={this.props.back}
            disabled={!this.props.enableBack}
            title="Back"
            size="sm"
            variant="secondary"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
        </div>
        <h2 className="menu-title-text">Tutorials</h2>
        <div className="menu-title-button">
          <ButtonGroup size="sm">
            <Button
              onClick={this.props.togglePin}
              variant="secondary"
              title={this.props.pinned ? ' Unpin' : ' Pin Open'}
            >
              <FontAwesomeIcon icon={faThumbtack} style={pinStyle} />
            </Button>{' '}
            <Button
              onClick={this.props.close}
              variant="secondary"
              title="Close"
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}

TitleBar.propTypes = {
  back: PropTypes.func,
  close: PropTypes.func,
  togglePin: PropTypes.func,
  pinned: PropTypes.bool,
  enableBack: PropTypes.bool,
};

TitleBar.defaultProps = {
  pinned: false,
  enableBack: false,
};

export default TitleBar;
